<script>
import axios from "axios";
import localStorageSvc from "@/services/localStorage";
import appModel from "@/shared/dataModels/app";
import domainHelper from "@/services/domainHelper";
export default {
  getHttp() {
    return axios.create({
      baseURL: domainHelper.getAPIHost()
    });
  },

  async get(u){
    try{
      let resp = await this.getHttp().get(u);
       return resp.data;
    }catch(err){
      // uiSvc.tr(null,err);
    }
  },
   async post(u,v){
    try{
      let resp = await this.getHttp().post(u,v);
      if(resp.data.ReturnStatus.ReturnCode==200){
        return resp.data;
      }
      else {
        if(resp.data.ReturnStatus.ReturnCode==401 || resp.data.ReturnStatus.ReturnMessage=='Access_Denied ')
        { 
           window.localStorage.clear();
           window.location = domainHelper.getPortalUrl(); 
        } else {
          // uiSvc.tr(null,resp.data.ReturnStatus.ReturnMessage);
          return null;
        }
      }
    }
    catch(err){      
      // uiSvc.tr(null,err);
    }
  },





  getSiteConf(siteID) {
    let userID = null;
    let u = localStorageSvc.getUser();
    try {
      userID = u;
    } catch (err) {      
      console.error(err);
    }

    let postData = {
      SiteID: siteID,
      UserID: userID
    };    
    return this.getHttp().post("api/loadMTGAppLink", postData);
  },

 
 loadDDWithCategory(menu, category) {
        var lanID = localStorageSvc.getLanID();
         let siteID = localStorageSvc.getSiteID();
        var key = "dd_" + menu + '_' + category + "_" + lanID;
        return new Promise((resolve, reject) => {
           
             let local = this.loadDDFromLocal(menu, lanID);
            if (local) {
                resolve(local);
            } else {
                let postData = {
                    MenuCode: menu,
                    Category: category,
                    LanguageID: lanID,
                    SiteID: siteID
                };
                this.getHttp().post('/api/LoadDDWithCategory', postData).then(res => {
                    let items = res.data.filter(item => item.Label);
                    localStorageSvc.set(key, items, true);
                    resolve(items);
                });
            }
        })
    },


 




  loadDD(menu) {
    var lanID = localStorageSvc.getLanID();
    let siteID = localStorageSvc.getSiteID();
    return new Promise((resolve, reject) => {
      let local = this.loadDDFromLocal(menu, lanID);
      if (local) {
        resolve(local);
      } else {
        let postData = {
          MenuCode: menu,
          LanguageID: lanID,
          SiteID: siteID
        };
        this.getHttp()
          .post("/api/loadMTGAppDD", postData)
          .then(res => {
            let items = res.data.filter(item => item.Label);
            let key = "dd_" + menu + "_" + lanID;
            localStorageSvc.set(key, items, true);
            resolve(items);
          })
          .catch(e => {
            console.error(e);
            reject();
          });
      }
    });
  },
  loadDDFromLocal(menu, lanID) {
    let key = "dd_" + menu + "_" + lanID;
    return localStorageSvc.get(key, true);
  },
  getDDValue(menu, label) {
    let postData = {
      SiteID: localStorageSvc.getSiteID(),
      MenuCode: menu,
      Label: label,
      LanguageID: localStorageSvc.getLan()
    };
    return this.getHttp().post("/api/GetDDFuzzyItemCode", postData);
  },

  getGoogleAddressComponents(place) {
    if (!place) return null;
    var address_components = place.address_components;
    var components = {};
    $.each(address_components, function(k, v1) {
      $.each(v1.types, function(k2, v2) {
        components[v2] = v1.long_name;
      });
    });
    var addr = appModel.addressModel();

    addr.AddressLine1='';
    if(components.street_number)
      addr.AddressLine1 += components.street_number+ ' ';
    if(components.route)
      addr.AddressLine1+=components.route += ' ';
    if(components.locality)
      addr.AddressLine1+=components.locality += ', ';

    if(components.administrative_area_level_1)
      addr.AddressLine1+=components.administrative_area_level_1 += ' ';
    if(components.postal_code)
      addr.AddressLine1+=components.postal_code;
    
    if (components.country == "United States") {
      addr.CountryTypeDD = 2;
    } else {
      addr.CountryTypeDD = 1;
    }
    addr.ProvinceDD = components.administrative_area_level_1;
 
    if(addr.ProvinceDD.startsWith('Qu'))
      addr.ProvinceDD = "Quebec";

    addr.StreetNumber = components.street_number;

    try {
      if (addr.CountryTypeDD == 1) {
        addr.PostalFsa = components.postal_code.slice(0, 3);
        addr.PostalLdu = components.postal_code.slice(4, 7);
      } else {
        addr.InternationalPostalCode = components.postal_code;
      }
    } catch (e) {
      console.error(e);
    }
    addr.City = components.locality;
    addr.StreetName = components.route;

    return addr;
  },

  getAddressModelFromGoogle(place) {
    let addrComponents = this.getGoogleAddressComponents(place);
    let addr = appModel.addressModel();
 

    return new Promise((resolve, reject) => {
      if (addrComponents) {
        addr.CountryTypeDD = addrComponents.CountryTypeDD;
        addr.StreetDirectionDD = addrComponents.StreetDirectionDD;
        addr.StreetNumber = addrComponents.StreetNumber;
        addr.City = addrComponents.City;
        addr.PostalFsa = addrComponents.PostalFsa;
        addr.PostalLdu = addrComponents.PostalLdu;
        addr.InternationalPostalCode = addrComponents.InternationalPostalCode;
        addr.AddressLine1 = addrComponents.AddressLine1;

        let call1;
        if (addrComponents.ProvinceDD) {
          if (addrComponents.CountryTypeDD == 1) {
            call1 = this.getDDValue("Province", addrComponents.ProvinceDD);
          } else {
            call1 = this.getDDValue("State", addrComponents.ProvinceDD);
          }
        } else {
          call1 = this.getDDValue("Province", "Ontario");
        }

        let postData = {
          CountryTypeDD: addrComponents.CountryTypeDD,
          Route: addrComponents.StreetName,
          SiteID: localStorageSvc.getSiteID()
        };
        let call2 = this.getHttp().post("/api/LoadStreetComponents", postData);

        axios.all([call1,call2]).then(
          axios.spread((r1, r2) => {              
            addr.ProvinceDD = Number(r1.data);
            if (r2.data.ReturnStatus.ReturnCode == 200) {
              addr.StreetName = r2.data.StreetName;
              addr.StreetTypeDD = r2.data.StreetTypeDD;
              addr.StreetDirectionDD = r2.data.StreetDirectionDD;
            } else {
              addr.StreetName = addrComponents.StreetName;
              addr.StreetTypeDD = null;
              addr.StreetDirectionDD = null;
            }
            resolve(addr);
          })
        );
      } else {
        reject();
      }
    });

    return addr;
  },

  getAddressDisplay(addr){
    let rv = ''; 


    if(addr.StreetNumber)
      rv+=addr.StreetNumber + ' ';
      if(addr.StreetName)
      rv+= addr.StreetName + ' ';
      if(addr.City)
      rv+= addr.City+' ';
    return rv;
  }
};
</script>
